import {Directive, ElementRef, Input, OnInit, Self} from '@angular/core';
import {NgControl} from '@angular/forms';
import * as moment from 'moment';
import {Moment} from 'moment';

@Directive({
    selector: '[azDateFormatter]',
    standalone: false
})
export class DateFormatterDirective implements OnInit {
  private el: HTMLInputElement;

  @Input() azDateFormatter!: string;

  constructor(
    private elementRef: ElementRef,
    @Self() private control: NgControl,
  ) {
    this.el = this.elementRef.nativeElement;
  }
  ngOnInit(): void {
    if (moment.isMoment(this.control.value)) {
      this.elementRef.nativeElement.value = this.control.value.format(this.azDateFormatter);
    }
    this.control.valueChanges?.subscribe((res: Moment) => {
      if (moment.isMoment(res) && this.azDateFormatter) {
        this.elementRef.nativeElement.value = res.format(this.azDateFormatter);
      }
    });
  }
}
